import axios from 'axios';
import Qs from 'qs';
import {
	dayEnd,
	dayStart,
} from "../components/DateUtil";

// const url = 'https://www.energydt.cn/api' //公司线上服务器
const url = 'https://local.vrmaker.vip:37086' //公司线上服务器
// const url = 'http://220.249.101.248:37086' //公司线上服务器


// 通过回路id查询极值
export const EXTREMUM_VALUES = (ids, nodes, type, date) => {
	return axiosApi("get", "/extremum/values")({
		ids: ids.join(","),
		nodes: nodes.join(","),
		type,
		"start": dayStart(date),
		"end": dayEnd(date),
	})
}

/**
 * 用Create方法来创建axios请求对象
 */

export const INITAXIOS = axios.create({
    timeout: 20000, // 请求超时时间
    baseURL: url, //线上公司服务器
    method: 'post',
    headers: {
        'Content-Type': "application/x-www-form-urlencoded",
    },
    transformRequest: data => {
        let result = Qs.stringify(data);
        return result
    }
})

/**
 * 用来创建普通请求方法
 * @param api
 * @returns {function(*=): Promise<AxiosResponse<T>>}
 */
export function axiosApi(type, api, header) {
    header ? header : header = {};
    return data => {
        switch (type) {
            case 'get':
                return INITAXIOS({
                    url: api,
                    params: data,
                    method: 'get',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'post':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'post',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'put':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'put',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
            case 'delete':
                return INITAXIOS({
                    url: api,
                    data: data,
                    method: 'delete',
                    headers: {
                        'authorization': 'Bearer ' + 'VrMakerToken',
                        ...header
                    }
                })
        }
    }
}


// -------  api区域  ------------
// 获取所有区域电能统计
const PowerAreasAnalysis = axiosApi('get', '/power/areas/analysis')

// 根据区域id获取区域能源分析
const PowerAnalysisArea = axiosApi('get', '/power/powerAnalysis/area')

// 根据区域id获取区域进线
const loopMasterArea = axiosApi('get', '/loop/master/area')

// 根据回路id和点位名获取相应数据历史曲线
const loopHistorycurve = axiosApi('get', '/diagram/loop/historycurve')

// 根据回路id和点位名获取相应数据历史曲线
const projectTime = axiosApi('get', '/project/time/deployment')

// 根据区域id获取区域回路的详细信息
const areaLoops = axiosApi('get', '/loop/area/all/details')

// 获取项目的日均负荷率
const dayLoad = axiosApi('get', '/diagram/influxdb/data/load')

// 按时间查询项目用电 
const diagramDay = axiosApi('get', '/diagram/generation')

// 按时间查询项目用电 
const diagramAreaDay = axiosApi('get', '/diagram/generation/area')

// 按时间查询回路三相温度
const loopTemperature = axiosApi('get', '/diagram/loop/historycurve/threetemperature')

// 查询报警事件
const alarmEvent = axiosApi('get', '/alarm/details/dateRange')

// 查询发电总功率
const getdailyInverter = axiosApi('get', '/diagram/historycurve/daily/inverter')

// 查询发电统计
const getdailyPowerInverter = axiosApi('get', '/diagram/historyCurve/dailyPower/inverter')


// 查询区域发电统计
const getdailyPowerInverterarea = axiosApi('get', '/diagram/historyCurve/dailyPower/inverter/area')

// 查询逆变器
const getinverter = axiosApi('get', '/loop/inverter')

// 查询区域逆变器
const getinverterarea = axiosApi('get', '/loop/inverter/area')

export default {
    PowerAreasAnalysis,
    PowerAnalysisArea,
    loopMasterArea,
    loopHistorycurve,
    projectTime,
    areaLoops,
    dayLoad,
    diagramDay,
    diagramAreaDay,
    loopTemperature,
    alarmEvent,
    getdailyInverter,
    getdailyPowerInverter,
    getinverter,
    getdailyPowerInverterarea,
    getinverterarea
}

